import * as service from "../service";

/**
 * Coupons per page in the student feed.
 *
 * Must match the server-side page size of the `getCoupons` route (see
 * `apps/uninfo-api/src/api/coupon/redeemCoupons.js`): a short page is how the
 * client knows the feed has ended.
 */
export const COUPON_PAGE_SIZE = 20;

/**
 * Fetch a page of coupons available for redemption.
 * Backend: GET /api/coupon/redeemCoupons/getCoupons
 *
 * The page is 1-based: page 1 is the first slice of the feed, page 2 the next
 * one, and so on. An empty page means the feed has ended.
 */
export const GetCouponAPI = async (page: number = 1) => {
  try {
    const resp = await service.call("GET", "api/coupon/redeemCoupons/getCoupons", {
      page,
    });
    return resp;
  } catch (err) {
    console.error(`GetCouponAPI ${err}`);
    return { status: -1, resp: err };
  }
};
